/**
 * @desc 参数名称选框
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** equipmentCode */
  equipmentCode: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.ParamCheckBoxResponse>>> {
  return defHttp.get({
    url: '/web/ParamManage/getParamBoxByEquipmentCode',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.ParamCheckBoxResponse>>> {
  return defHttp.get({
    url: '/mock/web/ParamManage/getParamBoxByEquipmentCode',

    params,
  });
}
